import React, { Component } from 'react';
import { withRouter } from 'react-router';

import LifelineShape from '@/components/LifelineShape';

import getLifelineUrl from '@/utils/getLifelineUrl';

import './style.css';

function Slide({ lifeline, cloud = false, active: isActive, ...props }) {
  const { firstName, lastName } = lifeline.data.remembering;
  return (
    <div className="lifeline-slide">
      <a
        href="#"
        className="lifeline-slide__link"
        onClick={e => {
          e.preventDefault();
          props.history.push(getLifelineUrl(lifeline));
        }}
        tabIndex={-1}
      >
        <div className="lifeline-slide__shape">
          <LifelineShape
            data={lifeline.data}
            cloud={false}
            paused={!isActive}
            animateOnMouseMove={false}
            transparent
            scale={2}
          />
        </div>
        <div className="lifeline-slide__title">
          {firstName} {lastName}
        </div>
      </a>
    </div>
  );
}

export default withRouter(Slide);
